<template lang="pug">
Common.signup-get-email-verification(v-else :title='title' :errors='errors')
  h1(slot='header') {{ title }}

  RequestEmail(slot='main'
    :route='$app.api.Routes.Accounts.Signup.Local.GetEmailVerification'
    submit-message='Request account verification email'
    type-message='email verification'
    @errors='onErrors')
</template>

<script>
import { Common, RequestEmail } from "AccountPages/components";
import "./scss";

export default {
  name: "SignupGetEmailVerification",
  components: {
    Common,
    RequestEmail,
  },
  data() {
    return {
      errors: [],
      boxBody: "RequestEmail",
      title: "Request a new verification email",
    };
  },
  methods: {
    onErrors(errors) {
      this.errors = errors;
    },
  },
};
</script>
